import useLightRadius from 'src/hooks/useLightRadius'

const SpotLight = () => {
  const { lightRadius, lights_on} = useLightRadius()
  
  return lights_on ? (
    <div
      className='light_circle'
    >
      <div
        style={{
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          width: `${lightRadius}px`,
          height: `${lightRadius}px`,
          borderRadius: '50%',
          backgroundColor: '#c4a26c',
          pointerEvents: 'all'
        }}
      />
    </div>
  ) : null
}

export default SpotLight
